import router from 'router';
import {
  hasUppercase,
  hasLowercase,
  hasNumber,
  hasSpecialChar,
} from './string';

import { configs } from '../config';

/**
 * Validate email address
 * @param {String} email
 * @returns {Boolean}
 */
export const isEmailValid = email => {
  const regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return regex.test(String(email).toLowerCase());
};

/**
 * Validate password strength
 * In order to register a user,
 * @param {String} password
 * @param {Number} strengthChecks
 * @returns {Boolean}
 */
export const isPasswordValid = (password, strengthChecks = 4) => {
  if (!password || password.length < 10) {
    return false;
  }

  let counter = 0;

  hasUppercase(password) && counter++;
  hasLowercase(password) && counter++;
  hasNumber(password) && counter++;
  hasSpecialChar(password) && counter++;

  return counter >= strengthChecks;
};

/**
 * Helper function to get the active tab from the router query
 */
function _getActiveTab() {
  const query = router.currentRoute.query;

  return configs().USER_TYPE_TABS.includes(query.tab)
    ? query.tab
    : configs().DEFAULT_USER_TYPE;
}

export const defaultAuthState = () => ({
  tabs: {
    values: configs().USER_TYPE_TABS,
    labels: {
      business: 'Business',
      journeys: 'Journeys',
    },
    activeTab: _getActiveTab(),
  },
});
